import styled from 'styled-components'

export const LoadingWrapper = styled.section`
  height: fit-content;
  width: fit-content;
  margin: auto;
`
